export default "__VITE_ASSET__ywO$nkhH__"